module.exports = __webpack_public_path__ + "static/media/user.f9ef8128.svg";